import { Application } from "@hotwired/stimulus";
import ConfettiController from "./confetti_controller";
import ShoppingListController from "./shopping_list_controller";
import ShuffleController from "./shuffle_controller";
import TagifyController from "./tagify_controller";

const application = Application.start();
application.register("confetti", ConfettiController);
application.register("shopping-list", ShoppingListController);
application.register("shuffle", ShuffleController);
application.register("tagify", TagifyController);
window.Stimulus = application;

export { application };
